import user from "./user";
import app from "./app";

export default {
    user,
    app,
};
